export const featureFlags =
  process.env.REACT_APP_FEATURE_FLAGS ?? "";

export const hasFeature = (
  flag: string,
  defaultValue = process.env.NODE_ENV === "development",
) =>
  defaultValue ||
  featureFlags
    .split(",")
    .map((f) => f.trim())
    .includes(flag);